module.exports = __webpack_public_path__ + "static/media/rupee-sign.24feb124.svg";